module.exports = function(service) {
	'use strict'
	service.factory('addToOtherByUrl',addToOtherByUrl);
	addToOtherByUrl.$inject=['postDataService','refreshtokenService','serverError','alertService','offlineError'];
	function addToOtherByUrl(postDataService,refreshtokenService,serverError, alertService, offlineError) {
        return function(url, data, type,successFunc, parentObj,order) {
            if(!postData) {
              postData = null
            }
            if(!data) {
                alertService('danger','Opps! ', (type)? type[0].toUpperCase() + type.slice(1)+ ' URL is required field.':'URL is required field.');
                parentObj[type+'UrlRequired'] = true;
                return
            }
            var postData = {
                'url':data
            }
            var postFunction = function() {   
              postDataService.save(url,postData).$promise.then(function(responseData){
                parentObj[type+'Url'] = '';
                if(responseData.addedItem) {
                  successFunc(responseData.addedItem,order)
                } else {
                  successFunc()
                }
                if(responseData.message) {
                  alertService('success','Success ', responseData.message, 2000);
                }
              }, function(error){
                if(!window.navigator.onLine) {
                  offlineError()
                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                  return
                }
                if(error.status ==401) {
                  var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {   
                        postFunction();
                      }
                    },
                    function(error) {
                      // report something
                    },
                    function(progress) {
                      // report progress
                  });
                }else if(error.status ==502) {
                  serverError();
                }else {
                  alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                }
              });
            }
            postFunction();
          }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/addToOtherByUrlService.js
// module id = 581
// module chunks = 0